{
  "shcCP": {
    "filters": {
      "sort": {
        "label": "Sort:",
        "priceASC": "price from lowest",
        "priceDESC": "price from highest",
        "nameASC": "name from a",
        "nameDESC": "name from z"
      }
    },
    "emptyProducts": "No products"
  }
}
